// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"B_NA_TheComp__zssBw"};